export default "assets/images/pattern-secondary-3eea0563.png";